import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=15abb23e&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=ts"
export * from "./SuccessPage.vue?vue&type=script&lang=ts"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=15abb23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abb23e",
  null
  
)

export default component.exports